var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurprisedUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 23.45,
    viewBox: "0 0 20.5 23.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surprised-user"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,11.2h-.2a5.35,5.35,0,1,1,.3,0ZM7.8,5.8a3.78,3.78,0,0,0,3.7,3.8h.3a3.8,3.8,0,1,0-4-3.8Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,22.8a5.32,5.32,0,0,1-1.9-8.1,8.48,8.48,0,0,1,10-2.4,1,1,0,0,1,.5,1.1.61.61,0,0,1-.9.5,7.27,7.27,0,0,0-8.5,2,3.36,3.36,0,0,0-.7,3,3.26,3.26,0,0,0,2,2.3,6.54,6.54,0,0,0,4.6.4.89.89,0,0,1,.4,1.7A7.88,7.88,0,0,1,5,22.8Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,17.7a5.91,5.91,0,0,1,5.9-5.9,5.9,5.9,0,0,1,0,11.8A5.91,5.91,0,0,1,10.4,17.7Zm.8,0a5.1,5.1,0,1,0,5.1-5.1A5.12,5.12,0,0,0,11.2,17.7Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.06,21.88l-.46-.08a2.46,2.46,0,0,1-1.11-.54,1.22,1.22,0,0,1-.39-1.38,1.46,1.46,0,0,1,.65-.74,2.94,2.94,0,0,1,1.66-.39,2.83,2.83,0,0,1,1.47.43,1.64,1.64,0,0,1,.49.49,1.15,1.15,0,0,1,.1,1.12,1.41,1.41,0,0,1-.63.67,3,3,0,0,1-1.27.41h-.51ZM18,19.73l-.76.16a5.51,5.51,0,0,1-1.72,0c-.27,0-.53-.11-.8-.16,0,0-.08,0-.08,0a4.17,4.17,0,0,0-.19.44.72.72,0,0,0,.06.43.89.89,0,0,0,.37.46,2.64,2.64,0,0,1,2.89,0A.91.91,0,0,0,18,19.73Zm-.35-.27a2.59,2.59,0,0,0-2.65,0A5.79,5.79,0,0,0,17.62,19.46Zm-.21,1.84a2.26,2.26,0,0,0-2.21,0A2.83,2.83,0,0,0,17.41,21.3Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,15l.18-.23a1.47,1.47,0,0,1,1.26-.54,2.58,2.58,0,0,1,1,.25c.14.07.19.16.14.27s-.16.12-.29.06a1.85,1.85,0,0,0-1.08-.22,1,1,0,0,0-.73.41,1.09,1.09,0,0,0-.13.17c-.09.11-.23.09-.34,0Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88,16.4a1.32,1.32,0,0,1,.34-.88,1.27,1.27,0,0,1,1.38-.37,1.2,1.2,0,0,1,.61.46,1.37,1.37,0,0,1,.14,1.52,1.29,1.29,0,0,1-1.74.61,1.25,1.25,0,0,1-.57-.59A1.57,1.57,0,0,1,16.88,16.4Zm2.25.09a1,1,0,0,0-.36-.83.78.78,0,0,0-.38-.2c-.67-.14-1,.28-1.13.86a1.41,1.41,0,0,0,0,.45.89.89,0,0,0,1.3.63A1,1,0,0,0,19.13,16.49Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.11,16.43a2.8,2.8,0,0,1,.05-.34,1.27,1.27,0,0,1,2.26-.5,1.33,1.33,0,0,1,.2,1.43,1.3,1.3,0,0,1-1.7.76,1.22,1.22,0,0,1-.57-.46A1.54,1.54,0,0,1,13.11,16.43Zm2.25.19a1.21,1.21,0,0,0-.3-.9.77.77,0,0,0-.31-.22.87.87,0,0,0-1.18.48A1.13,1.13,0,0,0,14,17.39a.81.81,0,0,0,.87,0A1,1,0,0,0,15.36,16.62Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.48,14.24a1.37,1.37,0,0,1,1,.52,1.84,1.84,0,0,1,.17.22.18.18,0,0,1-.06.24.18.18,0,0,1-.26-.07,1.69,1.69,0,0,0-.4-.4,1.3,1.3,0,0,0-1-.12,5.14,5.14,0,0,0-.55.2.21.21,0,0,1-.27-.07.19.19,0,0,1,.1-.25A2.73,2.73,0,0,1,18.48,14.24Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19.73a.91.91,0,0,1-.23,1.36,2.64,2.64,0,0,0-2.89,0,.89.89,0,0,1-.37-.46.72.72,0,0,1-.06-.43,4.17,4.17,0,0,1,.19-.44s.06,0,.08,0c.27.05.53.12.8.16a5.51,5.51,0,0,0,1.72,0Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.62,19.46a5.79,5.79,0,0,1-2.65,0A2.59,2.59,0,0,1,17.62,19.46Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41,21.3a2.83,2.83,0,0,1-2.21,0A2.26,2.26,0,0,1,17.41,21.3Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13,16.49a1,1,0,0,1-.52.91.89.89,0,0,1-1.3-.63,1.41,1.41,0,0,1,0-.45c.1-.58.46-1,1.13-.86a.78.78,0,0,1,.38.2A1,1,0,0,1,19.13,16.49Zm-1,.61a.54.54,0,0,0,.56-.55.53.53,0,0,0-.56-.55.54.54,0,0,0-.58.55A.55.55,0,0,0,18.11,17.1Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.36,16.62a1,1,0,0,1-.53.78.81.81,0,0,1-.87,0A1.13,1.13,0,0,1,13.57,16a.87.87,0,0,1,1.18-.48.77.77,0,0,1,.31.22A1.21,1.21,0,0,1,15.36,16.62ZM14.5,16a.55.55,0,1,0,0,1.1.56.56,0,0,0,.58-.55A.55.55,0,0,0,14.5,16Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.11,17.1a.55.55,0,0,1-.58-.55.54.54,0,0,1,.58-.55.53.53,0,0,1,.56.55A.54.54,0,0,1,18.11,17.1Zm0-.35a.2.2,0,0,0,.21-.2.2.2,0,0,0-.21-.2.2.2,0,0,0-.2.2A.21.21,0,0,0,18.1,16.75Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,16a.55.55,0,0,1,.57.55.56.56,0,0,1-.58.55.55.55,0,1,1,0-1.1Zm0,.75a.2.2,0,1,0,0-.4.2.2,0,1,0,0,.4Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#2c2c2c",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,16.75a.21.21,0,0,1-.2-.2.2.2,0,0,1,.2-.2.2.2,0,0,1,.21.2A.2.2,0,0,1,18.1,16.75Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.48,16.75a.2.2,0,1,1,0-.4.2.2,0,1,1,0,.4Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.95 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprisedUser);
export default __webpack_public_path__ + "static/media/surprised-user.e415305a51d2f23ba86ee06e324a312e.svg";
export { ForwardRef as ReactComponent };